import { render } from "./RecipeView.vue?vue&type=template&id=46ee93c6&scoped=true&ts=true"
import script from "./RecipeView.vue?vue&type=script&lang=ts"
export * from "./RecipeView.vue?vue&type=script&lang=ts"

import "./RecipeView.vue?vue&type=style&index=0&id=46ee93c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ee93c6"]])

export default __exports__